import React from 'react';

/**
 * Orologio animato con lancette che ruotano.
 * - Lancetta dei minuti: 1 giro / 6s
 * - Lancetta delle ore:  1 giro / 36s
 * Animazione realizzata via SMIL (nativa SVG, no JS).
 */
export function TickingClock({ className = 'w-5 h-5', strokeWidth = 2.5 }: { className?: string; strokeWidth?: number }) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden="true"
    >
      {/* Quadrante */}
      <circle cx="12" cy="12" r="10" />

      {/* Lancetta delle ore (corta, lenta) */}
      <line x1="12" y1="12" x2="15" y2="12">
        <animateTransform
          attributeName="transform"
          type="rotate"
          from="0 12 12"
          to="360 12 12"
          dur="36s"
          repeatCount="indefinite"
        />
      </line>

      {/* Lancetta dei minuti (lunga, veloce) */}
      <line x1="12" y1="12" x2="12" y2="7">
        <animateTransform
          attributeName="transform"
          type="rotate"
          from="0 12 12"
          to="360 12 12"
          dur="6s"
          repeatCount="indefinite"
        />
      </line>
    </svg>
  );
}
